module.exports = __webpack_public_path__ + "img/SVN.60ff2b3b.png";